module.exports = __webpack_public_path__ + "static/media/kf-3.2a8411c9.jpeg";